import React from 'react';
import { monedaTypeEnum } from '../../enum';
import { currencyFormat } from '../../util';

const RenderResumenDocumento = (props) => {

    const { ResumenFactura } = props;

    return (
        <>

            <div className="sixteen wide ui equal width grid">
                <div className="equal width row ">

                    <div className="column ten">
                        <div>
                            <strong>Moneda:</strong>
                        </div>
                        {
                            (ResumenFactura?.CodigoTipoMoneda?.CodigoMoneda === monedaTypeEnum.Dolar) && (
                                <div>
                                    <strong>Tipo de Cambio: </strong>
                                </div>
                            )
                        }
                        <div>
                            <strong>Sub-Total: </strong>
                        </div>
                        <div>
                            <strong>Ventas Grabadas: </strong>
                        </div>
                        <div>
                            <strong>Ventas Excentas: </strong>
                        </div>
                        <div>
                            <strong>Ventas Exoneradas: </strong>
                        </div>
                        <div>
                            <strong>Toltal No Sujeto: </strong>
                        </div>
                        <div>
                            <strong>Impuestos: </strong>
                        </div>
                        <div>
                            <strong>Descuentos: </strong>
                        </div>
                        <div>
                            <strong>Total: </strong>
                        </div>
                    </div>
                    <div className="column six montos-resumen">
                        <div>
                            {
                                ResumenFactura?.CodigoTipoMoneda?.CodigoMoneda === monedaTypeEnum.Dolar ?
                                    <p>{ResumenFactura?.CodigoTipoMoneda.CodigoMoneda} </p> :
                                    <p>CRC</p>
                            }
                        </div>
                        {
                            (ResumenFactura?.CodigoTipoMoneda?.CodigoMoneda === monedaTypeEnum.Dolar) && (
                                <div>
                                    <p>{currencyFormat(ResumenFactura?.CodigoTipoMoneda.TipoCambio, 2, "$")}</p>
                                </div>
                            )
                        }
                        <div>

                            {
                                ResumenFactura?.CodigoTipoMoneda?.CodigoMoneda === monedaTypeEnum.Dolar ?
                                    <p>{currencyFormat(ResumenFactura?.TotalVenta, 2, "$")}</p> :
                                    <p>{currencyFormat(ResumenFactura?.TotalVenta)}</p>
                            }

                        </div>
                        <div>
                            {
                                ResumenFactura?.CodigoTipoMoneda?.CodigoMoneda === monedaTypeEnum.Dolar ?
                                    <p>{currencyFormat(ResumenFactura?.TotalGravado, 2, "$")}</p> :
                                    <p>{currencyFormat(ResumenFactura?.TotalGravado)}</p>
                            }
                        </div>
                        <div>
                            {
                                ResumenFactura?.CodigoTipoMoneda?.CodigoMoneda === monedaTypeEnum.Dolar ?
                                    <p>{currencyFormat(ResumenFactura?.TotalExento, 2, "$")}</p> :
                                    <p>{currencyFormat(ResumenFactura?.TotalExento)}</p>
                            }
                        </div>
                        <div>
                            {
                                ResumenFactura?.CodigoTipoMoneda?.CodigoMoneda === monedaTypeEnum.Dolar ?
                                    <p>{currencyFormat(ResumenFactura?.TotalExonerado, 2, "$")}</p> :
                                    <p>{currencyFormat(ResumenFactura?.TotalExonerado)}</p>
                            }
                        </div>
                        <div>
                            {
                                ResumenFactura?.CodigoTipoMoneda?.CodigoMoneda === monedaTypeEnum.Dolar ?
                                    <p>{currencyFormat(ResumenFactura?.TotalNoSujeto, 2, "$")}</p> :
                                    <p>{currencyFormat(ResumenFactura?.TotalNoSujeto)}</p>
                            }
                        </div>
                        <div>
                            {
                                ResumenFactura?.CodigoTipoMoneda?.CodigoMoneda === monedaTypeEnum.Dolar ?
                                    <p>{currencyFormat(ResumenFactura?.TotalImpuesto, 2, "$")}</p> :
                                    <p>{currencyFormat(ResumenFactura?.TotalImpuesto)}</p>
                            }
                        </div>
                        <div>
                            {
                                ResumenFactura?.CodigoTipoMoneda?.CodigoMoneda === monedaTypeEnum.Dolar ?
                                    <p>{currencyFormat(ResumenFactura?.TotalDescuentos, 2, "$")}</p> :
                                    <p>{currencyFormat(ResumenFactura?.TotalDescuentos)}</p>
                            }
                        </div>
                        <div>
                            {
                                ResumenFactura?.CodigoTipoMoneda?.CodigoMoneda === monedaTypeEnum.Dolar ?
                                    <p>{currencyFormat(ResumenFactura?.TotalComprobante, 2, "$")}</p> :
                                    <p>{currencyFormat(ResumenFactura?.TotalComprobante)}</p>
                            }
                        </div>
                    </div>

                </div>
            </div>
        </>
    );
};

export default (RenderResumenDocumento);